import { render, staticRenderFns } from "./ib-snackbar.vue?vue&type=template&id=0a1807ed&lang=pug&"
import script from "./ib-snackbar.vue?vue&type=script&lang=js&"
export * from "./ib-snackbar.vue?vue&type=script&lang=js&"
import style0 from "./ib-snackbar.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ib-snackbar.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev39a/aleggett/thgit/web.app/lib.common/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a1807ed')) {
      api.createRecord('0a1807ed', component.options)
    } else {
      api.reload('0a1807ed', component.options)
    }
    module.hot.accept("./ib-snackbar.vue?vue&type=template&id=0a1807ed&lang=pug&", function () {
      api.rerender('0a1807ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/nav/ib-snackbar.vue"
export default component.exports